<label class="form-label" for="{{name}}">{{label}}<span *ngIf="isRequired"
    class="text-red-500 ml-1">*</span></label>
